import { useMutation } from '@apollo/client';

import { JoinEventInput } from '../../apollo/__generated__/graphql';
import { JOIN_EVENT } from '../graphql/mutation/joinEventMutation.graphql';

export const useJoinEventMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(JOIN_EVENT, { onCompleted });

  const joinEvent = (joinEventInput: JoinEventInput) => {
    mutate({
      variables: {
        joinEventInput,
      },
    });
  };

  return { joinEvent };
};
